import { compose, hoistStatics, lifecycle, withState, defaultProps, withPropsOnChange } from 'recompose';
import { translate } from 'react-i18next';
import Pagination from './Pagination';
import ph from './pagination.helper.';

const calc = async ({ count,
  page,
  pageSize,
  setCountPages,
  setPages,
  setShow,
  centralPagesCount,
  setShowStart,
  setShowEnd,
}) => {
  await setShow(false);
  const countPages = ph.getPageCount(count, pageSize);
  let pages = [];
  setShowEnd(true);
  setShowStart(true);
  if (countPages <= centralPagesCount + 2) {
    setShowEnd(false);
    setShowStart(false);
    pages = Array(...{ length: countPages }).map((el, i) => i);
  } else if (page < centralPagesCount - 1) {
    pages = Array(...{ length: centralPagesCount + 1 }).map((el, i) => i);
    setShowStart(false);
  } else if (page + 4 >= countPages) {
    pages = Array(...{ length: centralPagesCount + 1 }).map((el, i) => (
      (countPages - (centralPagesCount + 1)) + i));
    setShowEnd(false);
  } else if (page >= centralPagesCount - 1) {
    pages = Array(...{ length: centralPagesCount }).map((el, i) => (
      (page - Math.floor((centralPagesCount - 1) / 2)) + i));
  }
  await setCountPages(countPages);
  await setPages(pages);
  await setShow(pages.length > 1);
};

const enhance = compose(
  translate('portal'),
  withState('show', 'setShow', false),
  withState('pages', 'setPages', []),
  withState('countPages', 'setCountPages', 0),
  withState('centralPagesCount', 'setCentralPagesCount', 5),
  withState('showStart', 'setShowStart', true),
  withState('showEnd', 'setShowEnd', true),
  lifecycle({
    async componentDidMount() {
      calc(this.props);
    },
  }),
  defaultProps({
    page: 0,
    pageSize: 10,
    count: 0,
  }),
  withPropsOnChange(['count', 'page', 'pageSize'], (props) => {
    calc(props);
  }),
);

export default hoistStatics(enhance)(Pagination);



// WEBPACK FOOTER //
// ./src/components/pagination/index.js